import { render } from "./HomeBanner.vue?vue&type=template&id=8b6036e2&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=8b6036e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6036e2"]])

export default __exports__